export default __webpack_public_path__ + "static/media/icon-cart.a13c134f.svg";